module.exports = __webpack_public_path__ + "static/media/aplicacao.73f929ce.png";